import { useEffect } from "react";

const Etapa1 = ({isUpdate, productData, handleProductData,handleSubmit }) => {
  useEffect(() => {
    if (productData) {
      // Atualiza os campos do formulário
      handleProductData({
        sendType: productData.sendType || 1,
      });
    }
  }, []);
  return (
    <div className={"md:z-0  relative z-[99999]"}>
      <h1 className="mt-4">Pagamento</h1>
      <p className="text-[12px]">Aprenda sobre as configurações de parcelamento no checkout</p>
      <h3 className="mt-4">Métodos de pagamento</h3>
      <p className="text-[12px]">Selecione a baixo os  para definir a ordem que aparecerá no checkout e clique no botão 'Método padrão' para definir como pagamento padrão do checkout se o método de pagamento estiver selecionado</p>

      <div className="flex gap-4 mt-4">
        <div className="flex  w-full flex-col">
          <label>Selecione Método de pagamento abaixo</label>
          <select value={productData.paymentType} className="bg-[#313131] text-[12px] rounded-[8px] px-3 p-3 mt-2">
          <option >Selecione o metodo</option>
            <option value={"1"}>Pix</option>
          </select>
        </div>
        <div className="flex w-full flex-col">
          <label>Selecione Método padrão do checkout</label>
          <select value={productData.paymentType} className="bg-[#313131] text-[12px] rounded-[8px] px-3 p-3 mt-2">
            <option >Selecione o metodo</option>
            <option value={"1"}>Pix</option>
          </select>
        </div>
      </div>
      <div className="mt-4">
        <h1>Entrega de conteúdo</h1>
        <p className="text-[12px]">Selecione o tipo de entrega de conteúdo</p>

        <select
          value={productData?.sendType || 1}
          onChange={(e) => handleProductData({
            ...productData,
            sendType: parseInt(e.target.value)
          })}
          className="bg-[#313131] text-[12px] rounded-[8px] px-3 p-3 mt-2"
        >
            <option >Selecione o envio</option>
          <option value="1">E-mail</option>
        </select>
      </div>
      <div onClick={() => { handleSubmit() }} className="flex gap-2 mt-4  text-[14px]">
        <div className="px-2 cursor-pointer flex gap-2 items-center p-1 rounded-[8px] bg-[#478DF8]">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 7.96875C8.6409 7.96875 8.77602 8.02472 8.87565 8.12435C8.97528 8.22398 9.03125 8.3591 9.03125 8.5V9.5625H10.0938C10.2346 9.5625 10.3698 9.61847 10.4694 9.7181C10.569 9.81773 10.625 9.95285 10.625 10.0938C10.625 10.2346 10.569 10.3698 10.4694 10.4694C10.3698 10.569 10.2346 10.625 10.0938 10.625H9.03125V11.6875C9.03125 11.8284 8.97528 11.9635 8.87565 12.0632C8.77602 12.1628 8.6409 12.2188 8.5 12.2188C8.3591 12.2188 8.22398 12.1628 8.12435 12.0632C8.02472 11.9635 7.96875 11.8284 7.96875 11.6875V10.625H6.90625C6.76535 10.625 6.63023 10.569 6.5306 10.4694C6.43097 10.3698 6.375 10.2346 6.375 10.0938C6.375 9.95285 6.43097 9.81773 6.5306 9.7181C6.63023 9.61847 6.76535 9.5625 6.90625 9.5625H7.96875V8.5C7.96875 8.3591 8.02472 8.22398 8.12435 8.12435C8.22398 8.02472 8.3591 7.96875 8.5 7.96875ZM15.4062 5.84375V13.2812C15.4062 13.563 15.2943 13.8333 15.0951 14.0326C14.8958 14.2318 14.6255 14.3438 14.3438 14.3438H2.65625C2.37446 14.3438 2.10421 14.2318 1.90495 14.0326C1.70569 13.8333 1.59375 13.563 1.59375 13.2812V4.25C1.59375 3.96821 1.70569 3.69796 1.90495 3.4987C2.10421 3.29944 2.37446 3.1875 2.65625 3.1875H6.1977C6.4275 3.18807 6.65101 3.26258 6.8352 3.4L8.6773 4.78125H14.3438C14.6255 4.78125 14.8958 4.89319 15.0951 5.09245C15.2943 5.29171 15.4062 5.56196 15.4062 5.84375ZM2.65625 6.375H6.1977L7.6148 5.3125L6.1977 4.25H2.65625V6.375ZM14.3438 5.84375H8.6773L6.8352 7.225C6.65101 7.36242 6.4275 7.43693 6.1977 7.4375H2.65625V13.2812H14.3438V5.84375Z" fill="white" />
          </svg>
          {isUpdate? 'Editar' : 'Cadastrar'} Produto
        </div>
        <div className="bg-[#444444] cursor-pointer rounded-[8px] px-2 p-1 items-center">cancelar</div>
      </div>
    </div>
  )
}

export default Etapa1